export const traitCreatedBy = {};
export const createsTrait = {};
export function addTraitDependency(creatorKey, creates) {
    const createdKeys = Array.isArray(creates) ? creates : [creates];
    for (const createKey of createdKeys) {
        const current = traitCreatedBy[createKey] || [];
        traitCreatedBy[createKey] = [...current, creatorKey];
        const current2 = createsTrait[creatorKey] || [];
        createsTrait[creatorKey] = [...current2, createKey];
    }
}
